export const marketingFacts = {
  platformVolume: '$200M+',
  activeMerchants: '1,000+',
  cataloguedSkus: '500k+',
  yearsInBusiness: '7',
};
